import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Router from 'vue-router'
import i18n from "./i18n/i18n";
import store from './vuex/store'
import vueConfig from './vue-config'
import ElementUI from 'element-ui';
import request_url from './request_url.js'
import 'element-ui/lib/theme-chalk/index.css';
import Http from './utils/http'
import VueAnalytics from 'vue-analytics'
import systemSettings from './utils/systemSettings'

Vue.use(ElementUI)
Vue.use(vueConfig)
Vue.use(Http)
Vue.use(systemSettings)
Vue.config.productionTip = false

Vue.setValueByKey('api_path', request_url.api_url)
Vue.setValueByKey('cas_path', request_url.cas_url)
Vue.setValueByKey('www_path', request_url.www_url)
Vue.setValueByKey('ase_path', request_url.ase_url)
Vue.config.productionTip = false


Vue.component('Vue', () => Vue)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueAnalytics, {
  id: 'UA-166956644-1',
  router
});
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
